"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleContainer = exports.Title = exports.HeaderContainer = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const HeaderContainer = exports.HeaderContainer = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  hasTitle,
  theme
}) => ({
  display: 'flex',
  justifyContent: hasTitle ? 'space-between' : 'flex-end',
  alignItems: 'center',
  marginBottom: theme.spacing(4),
  gap: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(6)
  }
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['maxLines'])
})(({
  maxLines = 1
}) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: maxLines,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  userSelect: 'none'
}));
const TitleContainer = exports.TitleContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
//# sourceMappingURL=header.js.map